import { useMutation } from "@tanstack/react-query";
import { api } from "../api";

export function useResolvePromoCode(scope?: "pricing" | "marketing") {
  return useMutation({
    mutationFn: (code: string) =>
      api.resolvePromoCode(code, scope).then((r) => r.data),
  });
}
